import { queryClient } from "@services/query/queryClient";
import { getEffectiveUsernameOverride, type MeSession } from "@features/me/queries";
import { usePortalModeStore } from "@stores/usePortalModeStore";

export function hasPermission(permissionOrPermissions: string | string[]): boolean {
    if (Array.isArray(permissionOrPermissions)) {
        return permissionOrPermissions.some((permission) => hasPermission(permission));
    }

    const normalizedPermission = normalizePermission(permissionOrPermissions);
    if (!normalizedPermission) {
        return false;
    }

    return getCurrentPermissions().some((entry) => normalizePermission(entry) === normalizedPermission);
}

function getCurrentPermissions(): string[] {
    return queryClient.getQueryData<MeSession>([
        "me-session",
        usePortalModeStore.getState().viewMode,
        getEffectiveUsernameOverride(),
    ])?.permissions ?? [];
}

export function normalizePermission(value: string): string {
    return value.trim().toLowerCase();
}
